import * as React from 'react';
import style from './Top.scss';

type Props = {};

const Top: React.FunctionComponent<Props> = (props) => {
  const {} = props;

  return (
    <div className={style.top}>
      <div className={style.header}>Открытая информация</div>
      <div className={style.aside}>Powered by ELSA®</div>
    </div>
  );
};

export default React.memo(Top);